module.exports = __webpack_public_path__ + "media/ring.c35237be.wav";